import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import withLayout from "../../../components/desktop/layout/component";
import LeadForm from "../../../components/desktop/lead-form";
import style from "./style.css";
import CloseButton from "../../../components/shared/icon-cross";
import LeadKilometerDriven from "../../../components/desktop/lead-kilometer-driven";
import ErrorHandler from "../../../components/shared/with-error-handler";
import { Helmet } from "react-helmet-async";
import { getItem, getStringItem } from "../../../utils/helpers/storage-crud";
import { CITY_KEY, LEAD_FORM, ALTERNATE_LEAD_CITIES, LOCAL_STORAGE_KEYS, NUMBER, ACTIVE_VARIANT_SCREEN } from "../../../constants/app-constants";
import LeadProgressBar from "../../../components/desktop/lead-progress-bar";
import { FUNNEL_CONFIG } from "../../../utils/funnel/steps.desktop";
import LeadFormImage from "./images/lead-form.svg";
import LeadFormYear from "./images/lead-form-year.svg";
import LeadFuelType from "./images/lead-fuel-type.svg";
import { appUrl } from "../../../constants/url-constants";
const metaDescription = "Get an instant, fair, and transparent evaluation for your used car with CARS24's easy and efficient car valuation calculator.";

const CarEvaluation = ({
    history,
    match,
    flowName,
    leadSource,
    activateLastStep,
    selectedCity,
    resetLeadFormDataConnect,
    selectCityConnect,
    currentTabIndex,
    variantActiveScreen
}) => {

    const [formConfig, setFormConfig] = useState(null);
    const [backgroundImage, setbackgroundImage] = useState(LeadFormImage);

    useEffect(() => {
        if (currentTabIndex === NUMBER.THREE) {
            setbackgroundImage(LeadFormYear);
        } else if (currentTabIndex === NUMBER.FOUR) {
            if (variantActiveScreen === ACTIVE_VARIANT_SCREEN.FUELTYPE) {
                setbackgroundImage(LeadFuelType);
            }
        } else {
            setbackgroundImage(LeadFormImage);
        }
    }, [currentTabIndex, variantActiveScreen]);

    const onClickClose = () => {
        if (history.action === "POP" || history.action === "REPLACE") {
            history.push("/sell-used-cars");
        } else {
            history.goBack();
        }
    };

    /*
        update city in case no city is selected
        why - because car-evaluation doesnt contain a layout
    */
    useEffect(() => {
        if (!selectedCity.id) {
            const currentSelectedCity = getItem(CITY_KEY);
            if (currentSelectedCity && !currentSelectedCity.isVirtualCity) {
                selectCityConnect(
                    currentSelectedCity.id,
                    currentSelectedCity.name,
                    currentSelectedCity.image,
                    currentSelectedCity.url,
                    currentSelectedCity.viewAllCarsUrl
                );
            } else {
                //reset to default config if no city is selected
                setFormConfig(FUNNEL_CONFIG[LEAD_FORM.DEFAULT]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /*
        set a different lead flow
    */
    useEffect(() => {
        if (selectedCity.id) {
            let type = LEAD_FORM.DEFAULT;
            if (getStringItem(LOCAL_STORAGE_KEYS.ALTERNATE_LEAD_FLOW)) {
                if (leadSource === "original" &&
                    ALTERNATE_LEAD_CITIES.includes(selectedCity.id)) {
                    type = LEAD_FORM.ONE_STEP;
                }
            }
            if (type !== flowName) {
                resetLeadFormDataConnect();
            }
            setFormConfig(FUNNEL_CONFIG[type]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCity.id]);

    return (
        <React.Fragment>
            <Helmet>
                <meta name="ROBOTS" content="NOINDEX,FOLLOW" />
                <meta name="description" content={metaDescription} />
                <link href={`${appUrl()}/car-evaluation/`} rel="canonical" />
            </Helmet>
            {formConfig &&
            <div>
                <React.Fragment>
                    {!activateLastStep &&
                    <div className="row" styleName={"style.sellcarContainer"} style={{ backgroundImage: `url(${backgroundImage})` }}>
                        <a className="" styleName={"style.closeIcon"} onClick={onClickClose}>
                            <CloseButton />
                        </a>
                        <div className="col-10 mx-auto p-0">
                            {/* <ErrorHandler>
                                <LeadformSteps
                                    formConfig={formConfig}
                                    currentLeadStep={currentLeadStep}
                                    currentStep={"carDetail"}
                                />
                            </ErrorHandler> */}
                            <div className="col-6" styleName={"style.progressBar"}>
                                <LeadProgressBar
                                    type={formConfig.flowName} />
                            </div>
                            <ErrorHandler>
                                <LeadForm
                                    formConfig={formConfig}
                                    match={match} />
                            </ErrorHandler>
                        </div>
                    </div>
                    }
                    {(activateLastStep &&
                    <ErrorHandler>
                        <LeadKilometerDriven onCloseClick={onClickClose} />
                    </ErrorHandler>)
                    }
                </React.Fragment>
            </div>}
        </React.Fragment>
    );
};

CarEvaluation.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object.isRequired,
    activateLastStep: PropTypes.oneOfType([PropTypes.bool]),
    currentTabIndex: PropTypes.string,
    flowName: PropTypes.string,
    leadSource: PropTypes.object,
    selectedCity: PropTypes.string || PropTypes.object,
    resetLeadFormDataConnect: PropTypes.func,
    selectCityConnect: PropTypes.func,
    variantActiveScreen: PropTypes.string,
    setStepConnect: PropTypes.func,
    currentStep: PropTypes.string
};

export default withLayout(CarEvaluation, false, false);

